import Vue from "vue";
import VueI18n from "vue-i18n";
import options from "_private/config/lang";

Vue.use(VueI18n);

const i18n = new VueI18n(options);

export default i18n;
